<div [ngClass]="!(isAuthenticated() | async) ? 'container mt-5' : ''">
  <div class="card">
    <div class="card-body-generate">
      <div class="highcharts-loading">
        <div class="highcharts-loading-inner"></div>
      </div>
      <h3>
        Please wait a moment while we're requesting your trial report...
      </h3>
    </div>
  </div>
</div>
